import { X, Download, ExternalLink } from "lucide-react";

const CertificateModal = ({ certificate, onClose }) => {
  if (!certificate) return null;

  return (
    <div
      className="fixed inset-0 z-[999] bg-black/80 backdrop-blur-md flex items-center justify-center p-6 animate-in fade-in duration-300"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative bg-neutral-950 rounded-3xl border border-neutral-800 shadow-2xl max-w-7xl w-full overflow-hidden"
      >
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-neutral-800">
          <div>
            <h2 className="text-2xl font-bold text-white">
              {certificate.title}
            </h2>

            <p className="text-neutral-400 mt-1">
              {certificate.issuer} • {certificate.year}
            </p>
          </div>

          <button
            onClick={onClose}
            className="w-11 h-11 rounded-full hover:bg-neutral-800 flex items-center justify-center transition"
          >
            <X className="text-white" />
          </button>
        </div>

        {/* Certificate Viewer */}
        <div className="bg-gradient-to-br from-neutral-900 via-black to-neutral-900 p-10 overflow-auto max-h-[75vh] flex justify-center">
          <div className="bg-white rounded-xl shadow-[0_20px_60px_rgba(0,0,0,0.45)] p-6">
            <img
              src={certificate.image}
              alt={certificate.title}
              className="max-h-[65vh] rounded-lg object-contain"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-4 p-6 border-t border-neutral-800">
          <a
            href={certificate.image}
            download
            className="flex items-center gap-2 px-5 py-3 rounded-xl bg-neutral-800 hover:bg-neutral-700 text-white transition"
          >
            <Download size={18} />
            Download
          </a>

          <a
            href={certificate.link}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-3 rounded-xl bg-white text-black font-semibold hover:bg-neutral-200 transition"
          >
            <ExternalLink size={18} />
            Open Original
          </a>
        </div>
      </div>
    </div>
  );
};

export default CertificateModal;
